import React, { useEffect, useState } from "react";
import { toPersianNum, toEnglishNum } from "../../assets/utils";
import Calender from "../calender/calender.component";
import { Select, Tag } from "antd";
import {
  selectLoadingDescription,
  selectEvacuationDescription,
  selectNewRequestLoadWeight,
  selectNewRequestSizes_length,
  selectNewRequestSizes_width,
  selectNewRequestSizes_height,
  selectNewRequestBargiryDate,
  selectNewRequestTakhliehDate,
  selectPackagingType,
  selectPostalCode,
  selectNewRequestCalenderBargiry_show,
  selectNewRequestCalenderTakhlieh_show,
  selectNewRequestAuctionList,
  selectNewRequestSelectedAuction,
} from "../../redux/newRequest/newRequest.selectors";
import {
  setLoadingDescription,
  setEvacuationDescription,
  setLoadWeight,
  setSizeLength,
  setSizeWidth,
  setSizeHeight,
  setBargiryDate,
  setTakhliehDate,
  setPackagingType,
  setPostalCode,
  setCalenderBargiryShow,
  setCalenderTakhliehShow,
  setAuction,
  setAlertNotifShow,
} from "../../redux/newRequest/newRequest.actions";
import { useDispatch, useSelector } from "react-redux";
import {
  TextAreaStyled,
  InputStyled,
  InputContainer,
  MoreInfoStylrd,
} from "./heavyReqPreForm.styles";
import ReactSelect from "react-select";
import socket from "../../assets/socketConnection";
const HeavyReqPreForm = ({ selectedDate, setShow }) => {
  const showCalender = useSelector(selectNewRequestCalenderBargiry_show);
  const showCalenderTakhlie = useSelector(
    selectNewRequestCalenderTakhlieh_show
  );
  const onTimeClick = () => {
    dispatch(setCalenderTakhliehShow(false));
    dispatch(setCalenderBargiryShow(true));
  };
  const onTimeEvClick = () => {
    dispatch(setCalenderBargiryShow(false));
    dispatch(setCalenderTakhliehShow(true));
  };
  const { Option } = Select;
  const [packTypes, setPackTypes] = useState("");
  const [selected, setSelected] = useState("");
  useEffect(() => {
    socket.emit("get_packs", {});
    socket.on("response_packs", (res) => {
      console.log("packs", res);
      setPackTypes(res);
    });
    socket.emit("get_postal_code", {});
    socket.on("response_postal_code", (res) => {
      console.log("packs", res.result.postal_code);
      dispatch(setPostalCode(toEnglishNum(res.result.postal_code)));
    });
  }, []);
  const dispatch = useDispatch();
  const handle_Ldesc_change = (e) => {
    const value = e.currentTarget.value;
    dispatch(setLoadingDescription(value));
  };
  const handle_Edesc_change = (e) => {
    const value = e.currentTarget.value;
    dispatch(setEvacuationDescription(value));
  };
  const handle_weight_change = (e) => {
    dispatch(setLoadWeight(toEnglishNum(e.currentTarget.value)));
  };
  const handle_length_change = (e) => {
    dispatch(setSizeLength(toEnglishNum(e.currentTarget.value)));
  };
  const handle_width_change = (e) => {
    dispatch(setSizeWidth(toEnglishNum(e.currentTarget.value)));
  };
  const handle_height_change = (e) => {
    dispatch(setSizeHeight(toEnglishNum(e.currentTarget.value)));
  };
  // const handle_Ldate_change = (e) => {
  //   dispatch(setBargiryDate(e.currentTarget.value));
  // };
  const handleChangePackaging = (value) => {
    console.log(`selected ${value}`);
    dispatch(setPackagingType(value));
  };
  const handleChangePostalCode = (e) => {
    dispatch(setPostalCode(toEnglishNum(e.currentTarget.value)));
  };
  const selectedAuction = (value) => {
    console.log(`selected ${value}`);
    dispatch(setAuction(value));
  };
  const loadingDescription = useSelector(selectLoadingDescription);
  const evacuationDescription = useSelector(selectEvacuationDescription);
  const loadWeight = useSelector(selectNewRequestLoadWeight);
  const loadLength = useSelector(selectNewRequestSizes_length);
  const loadWidth = useSelector(selectNewRequestSizes_width);
  const loadHeight = useSelector(selectNewRequestSizes_height);
  const loadingDate = useSelector(selectNewRequestBargiryDate);
  const evacuationDate = useSelector(selectNewRequestTakhliehDate);
  const PackagingType = useSelector(selectPackagingType);
  const PostalCode = useSelector(selectPostalCode);
  const AuctionList = useSelector(selectNewRequestAuctionList);
  const SelectedAuction = useSelector(selectNewRequestSelectedAuction);
  return (
    <>
      <InputContainer>
        <InputStyled
          type="text"
          value={toPersianNum(loadWeight)}
          onChange={(e) => handle_weight_change(e)}
          placeholder="وزن (کیلوگرم) "
        />
        <InputStyled
          type="text"
          value={toPersianNum(loadLength)}
          onChange={(e) => handle_length_change(e)}
          placeholder="طول"
        />
        <InputStyled
          type="text"
          value={toPersianNum(loadWidth)}
          onChange={(e) => handle_width_change(e)}
          placeholder="عرض"
        />
        <InputStyled
          type="text"
          value={toPersianNum(loadHeight)}
          onChange={(e) => handle_height_change(e)}
          placeholder="ارتفاع"
        />

        <InputStyled
          type="text"
          value={toPersianNum(PostalCode)}
          onChange={(e) => handleChangePostalCode(e)}
          placeholder="کد پستی"
        />
        <Select
          className="select___packaging__type"
          onChange={handleChangePackaging}
          defaultValue={PackagingType ? PackagingType : "بسته بندی"}
        >
          {packTypes &&
            packTypes.map((pack, index) => (
              <Option value={pack._id}>{pack.pname}</Option>
            ))}
        </Select>
      </InputContainer>
      <div className="d-flex mt-4 mb-3">
        <Select
          className="select___auction__time"
          onChange={selectedAuction}
          defaultValue={SelectedAuction ? SelectedAuction : "زمان پیشنهادگیری"}
        >
          {AuctionList &&
            AuctionList.map((auction, index) => (
              <Option value={auction._id}>{auction.caption}</Option>
            ))}
        </Select>
      </div>
      <div
        className="mt-2 p-2 position-relative"
        style={{ backgroundColor: "#eaebed", borderRadius: "10px" }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          className="svg"
        >
          <g id="Group_1124" transform="translate(.244)">
            <g
              id="Rectangle_1923"
              fill="none"
              stroke="#2a2e43"
              transform="translate(-.244)"
            >
              <rect width="12" height="12" stroke="none" rx="4" />
              <rect width="11" height="11" x=".5" y=".5" rx="3.5" />
            </g>
            <path
              id="Line_38"
              d="M0 4L0 0"
              className="cls-2"
              transform="translate(5.756 2)"
            />
            <path
              id="Line_39"
              d="M0 0L2.5 1.5"
              className="cls-2"
              transform="translate(6 6)"
            />
          </g>
        </svg>
        <button onClick={onTimeClick} className="w-100 font-weight-bold">
          {loadingDate.value ? toPersianNum(loadingDate.value) : "زمان بارگیری"}
        </button>
      </div>
      {showCalender && (
        <div className="submit-req-pre__calender">
          <Calender />
        </div>
      )}
      <div>
        <TextAreaStyled
          className="text-area"
          name=""
          id=""
          cols="30"
          rows="2"
          placeholder="شرح بارگیری"
          onChange={handle_Ldesc_change}
          value={loadingDescription}
        ></TextAreaStyled>
      </div>
      <div
        className="mt-2 p-2 position-relative"
        style={{ backgroundColor: "#eaebed", borderRadius: "10px" }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          className="svg"
        >
          <g id="Group_1124" transform="translate(.244)">
            <g
              id="Rectangle_1923"
              fill="none"
              stroke="#2a2e43"
              transform="translate(-.244)"
            >
              <rect width="12" height="12" stroke="none" rx="4" />
              <rect width="11" height="11" x=".5" y=".5" rx="3.5" />
            </g>
            <path
              id="Line_38"
              d="M0 4L0 0"
              className="cls-2"
              transform="translate(5.756 2)"
            />
            <path
              id="Line_39"
              d="M0 0L2.5 1.5"
              className="cls-2"
              transform="translate(6 6)"
            />
          </g>
        </svg>
        <button onClick={onTimeEvClick} className="w-100 font-weight-bold">
          {evacuationDate.value
            ? toPersianNum(evacuationDate.value)
            : "زمان تخلیه "}
        </button>
      </div>
      {showCalenderTakhlie && (
        <div className="submit-req-pre__calender">
          <Calender />
        </div>
      )}
      <div>
        <TextAreaStyled
          className="text-area"
          name=""
          id=""
          cols="30"
          rows="2"
          placeholder="شرح تخلیه"
          onChange={handle_Edesc_change}
          value={evacuationDescription}
        ></TextAreaStyled>
      </div>
      {/* 
      <MoreInfoStylrd onClick={() => dispatch(setAlertNotifShow(true))}>
        تایید
      </MoreInfoStylrd> */}
    </>
  );
};

export default HeavyReqPreForm;
